import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

export default function AdminCategories() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ slug: "", name: "", description: "" });

  const load = () => api.get("/api/categories").then(({data}) => setList(data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/api/admin/categories", form);
      toast.success("Created");
      setForm({ slug: "", name: "", description: "" });
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  };

  const remove = async (c) => {
    if (!window.confirm(`Delete category ${c.name}?`)) return;
    await api.delete(`/api/admin/categories/${c.id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div data-testid="admin-categories">
      <div className="label-eyebrow">Categories</div>
      <h1 className="font-display font-black text-3xl mt-1">Course categories</h1>

      <form onSubmit={add} className="mt-6 bg-white border border-[#E5E7EB] rounded-xl p-6 grid md:grid-cols-4 gap-3 items-end">
        <div>
          <label className="text-sm font-semibold">Slug</label>
          <input data-testid="cat-slug" required value={form.slug} onChange={(e) => setForm({...form, slug: e.target.value})}
            className="w-full mt-1 border border-[#E5E7EB] rounded-md px-3 py-2 text-sm" placeholder="e.g. coaching" />
        </div>
        <div>
          <label className="text-sm font-semibold">Name</label>
          <input data-testid="cat-name" required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})}
            className="w-full mt-1 border border-[#E5E7EB] rounded-md px-3 py-2 text-sm" />
        </div>
        <div>
          <label className="text-sm font-semibold">Description</label>
          <input value={form.description} onChange={(e) => setForm({...form, description: e.target.value})}
            className="w-full mt-1 border border-[#E5E7EB] rounded-md px-3 py-2 text-sm" />
        </div>
        <button data-testid="cat-add" type="submit" className="btn-primary">Add</button>
      </form>

      <div className="mt-6 bg-white border border-[#E5E7EB] rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F3F4F6]">
            <tr><th className="px-4 py-3 text-left">Slug</th><th className="px-4 py-3 text-left">Name</th><th className="px-4 py-3 text-left">Description</th><th className="px-4 py-3 text-right">Actions</th></tr>
          </thead>
          <tbody>
            {list.map((c) => (
              <tr key={c.id} className="border-t border-[#E5E7EB]">
                <td className="px-4 py-3 font-mono text-xs">{c.slug}</td>
                <td className="px-4 py-3 font-semibold">{c.name}</td>
                <td className="px-4 py-3 text-[#4B5563]">{c.description}</td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => remove(c)} className="p-1.5 hover:bg-[#FEE2E2] rounded">
                    <Trash2 className="w-4 h-4 text-[#DC2626]" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
